import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Equipment_ds_equipment_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseId?: number, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MacAddress?: string, TypeId?: number, LocationContainers?: { EquipmentId?: number, LocationContainerId?: number, LocationContainer?: { Name?: string, TypeId?: number, WarehouseId?: number, Warehouse?: { Name?: string } } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Equipment/datasources/ds_equipment_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseId?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MacAddress?: string, TypeId?: number, LocationContainers?: { EquipmentId?: number, LocationContainerId?: number, LocationContainer?: { Name?: string, TypeId?: number, WarehouseId?: number, Warehouse?: { Name?: string } } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Equipment/datasources/ds_equipment_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseId?: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MacAddress?: string, TypeId?: number, LocationContainers?: { EquipmentId?: number, LocationContainerId?: number, LocationContainer?: { Name?: string, TypeId?: number, WarehouseId?: number, Warehouse?: { Name?: string } } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Equipment/datasources/ds_equipment_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseId?: number, fullTextSearch?: string    }) {
      return false;
    }
}
